import React from "react";
import "../../assets/style/attendance/search-filter.css";
export const SearchFilter = ({ data, setSearchString, placeholder }) => {
  const handleChange = (e) => {
    const targetValue = e.target.value.trim();

    setSearchString(targetValue);
  };
  return (
    <>
      {setSearchString && (
        <div>
          <input
            className="form-control pb-2"
            onChange={handleChange}
            type="search"
            value={data}
            name="search"
            placeholder={placeholder || "Search"}
          />
        </div>
      )}
    </>
  );
};
